/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentHistoryResponse {
    getFixupPrototypeFunction() { return AssessmentHistoryResponse.fixupPrototype; }

    static newInstance(model: Partial<AssessmentHistoryResponse>): AssessmentHistoryResponse {
        let obj = Object.assign(new AssessmentHistoryResponse(), model);
        AssessmentHistoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentHistoryResponse>): AssessmentHistoryResponse {
        if (!model) return null;
        return AssessmentHistoryResponse.newInstance(<AssessmentHistoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentHistoryResponse) {
        if (!obj) return;

        models.AssessmentHistoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentHistoryResponse): boolean {
        Object.setPrototypeOf(obj, AssessmentHistoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.assessment_history) {
            for (let val of this.assessment_history) {
                models.AssessmentHistory.fixupPrototype(val);
            }
        }
    }

    /**
     * Number of controls in the standard
     */
    total_count: number;

    /**
     * Page number
     */
    page_count: number;

    /**
     * list of assessment history entries.
     */
    assessment_history: Array<models.AssessmentHistory>;

}
